import { StorageKey } from 'common/context/Storage'
import { env } from 'common/env'

import { configuration } from './BaseApi'
import { callBackend } from './fetch'

export class LoginApi {
  async login(username: string, password: string): Promise<boolean> {
    const form = 'username=' + encodeURIComponent(username) + '&password=' + encodeURIComponent(password)

    const options: RequestInit = {
      method: 'POST',
      body: form,
      headers: {
        'secure-cookie': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }

    try {
      await callBackend(configuration.basePath + '/api/login', options)
      localStorage.setItem(StorageKey.Authenticated, 'true')
      return Promise.resolve(true)
    } catch (e: any) {
      const message = await e?.text?.().catch(() => '')
      if (e?.status === 423 || message?.toLowerCase().includes('temporarily locked')) {
        localStorage.setItem(StorageKey.ApiError, message || 'Account is temporarily locked. Please try again later.')
      } else if (e?.status === 401) {
        localStorage.setItem(StorageKey.ApiError, 'Incorrect Username or Password')
      } else {
        localStorage.setItem(StorageKey.ApiError, 'No connection to the server')
      }
      return Promise.resolve(false)
    }
  }

  async getAuthCookie(token: string): Promise<Response> {
    console.log('Logging in by token, interface id:', env.interfaceId)
    const options: RequestInit = {
      method: 'GET',
      headers: {
        'secure-cookie': 'true',
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Access-Token': token,
        'interface-id': env.interfaceId,
      },
    }

    return callBackend(configuration.basePath + '/api/token-login', options)
  }

  async loginByToken(tokenParam: string): Promise<boolean> {
    if (localStorage.getItem(StorageKey.Authenticated)) {
      await this.logout()
    }
    try {
      const response = await this.getAuthCookie(tokenParam)
        if (response.status === 200) {
          localStorage.setItem(StorageKey.Authenticated, 'true')
        return true
        }
      return false
    } catch {
      return false
    }
  }

  async logout(): Promise<boolean> {
    const options: RequestInit = { method: 'GET' }

    try {
      await callBackend(configuration.basePath + '/api/logout', options)
      localStorage.removeItem(StorageKey.Authenticated)
      localStorage.removeItem(StorageKey.TokenExpiration)
      return Promise.resolve(true)
    } catch (e) {
      return Promise.resolve(false)
    }
  }
}
